import { useAlert } from "@prismicio/editor-ui"
import { useMutation } from "@tanstack/react-query"

import type { MediaAssetOrExternalImage } from "../../core/MediaLibrary/hooks/mediaLibraryData"
import { uploadMedia } from "../../core/MediaLibrary/hooks/useMediaLibraryUpload"
import { useEditorConfig } from "../../EditorConfig"

interface UseImageFieldImageUploadArgs {
  onMediaSelected: (media: MediaAssetOrExternalImage) => void
}

export function useImageFieldImageUpload(args: UseImageFieldImageUploadArgs) {
  const { onMediaSelected } = args

  const config = useEditorConfig()
  const { showAlert } = useAlert()

  const { mutate: uploadImage, isPending: isUploadingImage } = useMutation({
    mutationFn: (file: File) =>
      uploadMedia({
        file,
        config,
      }),
    onSuccess: (media) => {
      onMediaSelected(media)
    },
    onError: () => {
      showAlert({
        title: "Error uploading image",
        subtitle: "Please try again",
      })
    },
  })

  return {
    uploadImage,
    isUploadingImage,
  }
}
